import IncomeTable from '@my-pages/features/employment/components/IncomeTable.tsx';
import ToggleEmploymentFormButton from '@my-pages/features/employment/components/ToggleEmploymentFormButton.tsx';
import { IEmploymentInfo } from '@shared/integrations/taf-api/v2/models';

interface IIncomeCardProps {
    employments?: IEmploymentInfo[] | null;
    onClickChange: any;
}

const IncomeCard = ({ employments, onClickChange }: IIncomeCardProps) => {
    const text = 'Lönehöjning, enligt kollektivtal behöver du inte meddela oss – det uppdateras automatiskt inom 1–2 månader efter det nya avtalet börjar gälla.';
    return (
        <div className='card card-body mb-4'>
            <div className='collapse-toggle fade-in-medium'>
                <div className='row'>
                    <div className='col-12'>
                        <h3>Inkomst</h3>
                        {!employments || (!employments[0] && <p>Vi saknar information om din nuvarande inkomst.</p>)}
                        {employments && employments[0] && (
                            <>
                                <IncomeTable employment={employments[0]} />
                            </>
                        )}
                        <ToggleEmploymentFormButton
                            text={text}
                            onClickChange={onClickChange}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncomeCard;
